<template>
    <div class="services-details-area d-flex align-items-center justify-content-center" style="min-height: 100vh;">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-12">
                    <div class="services-details-image text-center mb-4">
                        <img src="../../assets/images/services/facial-aesthetics/face-improvement/face_main_page.webp" alt="image">
                    </div>

                    <div class="services-details-content">
                        <u><h3>{{ $t('face_improvement_title') }}</h3></u>
                        <p>{{ $t('face_improvement_p') }}</p>
                    </div>

                    <div class="services-details-content">
                        <u><h3>{{ $t('face_improvement_technic_title') }}</h3></u>
                        <p>{{ $t('face_improvement_technic_p') }}</p>
                        <ol class="text-start d-inline-block">
                            <li>{{ $t('face_improvement_technic_li_1') }}</li>
                            <li>{{ $t('face_improvement_technic_li_2') }}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>


    export default {
        name: 'FaceImprovement',
        
    };
    
</script>
